<template lang="html">
    <div
        :class="[
            `vs-tabs-${color}`,
            `vs-tabs-position-${position}`,
            { 'hidden-content': !hasTabContent }
        ]"
        class="con-vs-tabs vs-tabs"
    >
        <div class="con-ul-tabs" :class="{ hidden: hideTabs }">
            <ul
                ref="ul"
                :class="[`ul-tabs-${alignment}`]"
                class="ul-tabs tabs-shadow-none vs-tabs--ul"
            >
                <li
                    v-for="(child, index) in children"
                    ref="li"
                    :class="{ activeChild: childActive == index }"
                    :style="childActive == index ? styleTab : {}"
                    :key="index"
                    class="vs-tabs--li"
                    @mouseover="hover = true"
                    @mouseout="hover = false"
                >
                    <button
                        v-on="child.listeners"
                        v-bind="child.attrs"
                        :style="styleAlignIcon(child.icon)"
                        class="vs-tabs--btn"
                        :class="`${child.class} ${child.disabled ? 'disabled' : ''}`"
                        :disabled="child.disabled"
                        type="button"
                        @click="activateTabForIndex(index)"
                    >
                        <vx-basic-icon
                            v-if="child.icon"
                            :icon-pack="child.iconPack"
                            :icon="child.icon"
                            size="4"
                            class="vs-tabs--btn-icon"
                        />
                        <span v-if="child.label">{{ child.label }}</span>
                    </button>

                    <button v-if="child.tag" class="vs-tabs--btn-tag" @click="clickTag(child)">
                        <vs-icon
                            :icon-pack="child.iconPack"
                            :icon="child.tag"
                            :color="child.tagColor"
                        />
                    </button>
                </li>
            </ul>
            <span :style="stylex" class="line-vs-tabs" />
        </div>
        <div class="con-slot-tabs" :class="{ 'hidden-tabs': hideTabs }">
            <slot />
        </div>
    </div>
</template>

<script>
import _color from '@/assets/utils/color.js'
export default {
    name: 'vx-tabs',
    props: {
        value: {
            default: 0,
            type: [Number, String]
        },
        color: {
            default: 'primary',
            type: String
        },
        tagColor: {
            default: 'primary',
            type: String
        },
        alignment: {
            default: 'left',
            type: String
        },
        position: {
            default: 'top',
            type: String
        },
        hideTabs: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        topx: 'auto',
        heightx: 2,
        hover: false,
        children: [],
        childActive: 0,
        leftx: 0,
        widthx: 0,
        these: false,
        isActive: true
    }),
    computed: {
        hasTabContent() {
            return this.$children.any((child) => child.$children.any())
        },
        styleTab() {
            return {
                color: _color.getColor(this.color, 1)
            }
        },
        stylex() {
            return {
                top: `${this.topx}px`,
                left: `${this.leftx}px`,
                width: `${this.widthx}px`,
                height: `${this.heightx}px`,
                background: `linear-gradient(30deg, ${_color.getColor(
                    this.color,
                    1
                )} 0%, ${_color.getColor(this.color, 0.5)} 100%)`,
                boxShadow: `0px 0px 8px 0px ${_color.getColor(this.color, 0.5)}`,
                transform: `scaleX(${this.these ? 1.3 : 1})`
            }
        },
        tabLabels() {
            return this.children.map((c) => c.label)
        },
        selectedTabElement() {
            if (this.hideTabs) {
                return null
            }

            return this.getTabElementForIndex(this.childActive)
        }
    },
    watch: {
        value(index) {
            const activeIndex = this.parseIndex(index)
            this.activateTabForIndex(activeIndex)
        },
        tabLabels: {
            handler: function (val) {
                this.$nextTick(this.changePositionLine)
            },
            deep: true
        },
        childActive: {
            handler: function (selectedIndex) {
                this.$emit('tab-clicked', selectedIndex)
            },
            immediate: true
        }
    },
    methods: {
        clickTag(child) {
            this.$emit('click-tag', child)
        },
        styleAlignIcon(icon) {
            return icon ? 'display:flex;align-items:center' : ''
        },
        parseIndex(index) {
            let activeIndex = this.childActive
            if (index < 0) {
                activeIndex = 0
            } else if (index >= this.$children.length) {
                activeIndex = this.$children.length - 1
            } else if (typeof this.$children[index].$attrs.disabled === 'undefined') {
                activeIndex = parseInt(index)
            }
            return activeIndex
        },
        getTabElementForIndex(index) {
            if (!this.$refs.li) {
                return null
            }
            return this.$refs.li[index]
        },
        activateTabForIndex(index) {
            this.$nextTick(() => {
                const tabElement = this.getTabElementForIndex(index)
                if (this.childActive == index && tabElement) {
                    this.these = true
                    tabElement.classList.add('isActive')
                    setTimeout(() => {
                        tabElement.classList.remove('isActive')
                        this.these = false
                    }, 200)
                }
                this.$children.map((item, item_index) => {
                    if (item_index != index) {
                        item.active = false
                    }
                })
                if (this.childActive > index) {
                    this.$children[index].invert = true
                    this.$children[this.childActive].invert = false
                } else {
                    this.$children[this.childActive].invert = true
                    this.$children[index].invert = false
                }
                this.$children[index].active = true
                this.childActive = index
                if (this.value != index) {
                    this.$emit('input', this.childActive)
                }
                if (this.position == 'left' || this.position == 'right') {
                    this.$children[index].vertical = true
                }
                this.changePositionLine(tabElement)
            })
        },
        changePositionLine(tabElement) {
            tabElement = tabElement || this.selectedTabElement
            if (!tabElement) {
                return
            }
            if (this.position == 'left' || this.position == 'right') {
                this.topx = tabElement.offsetTop
                this.heightx = tabElement.offsetHeight
                this.widthx = 2
            } else {
                const update = () => {
                    this.leftx = tabElement.offsetLeft
                    this.widthx = tabElement.offsetWidth
                    this.topx =
                        tabElement.offsetHeight +
                        (tabElement.getBoundingClientRect().top -
                            this.$refs.ul.getBoundingClientRect().top -
                            4)
                }
                update()
            }
        }
    },
    activated() {
        var existingIds = this.$children.map((c) => c._uid)
        this.children.removeWhere((c) => !existingIds.contains(c.id))
    },
    mounted() {
        const activeIndex = this.parseIndex(this.value)
        this.childActive = activeIndex

        this.activateTabForIndex(activeIndex, true)
    }
}
</script>

<style lang="scss" scoped>
.tabs-shadow-none {
    box-shadow: none;
}
.hidden-tabs {
    ::v-deep .vs-tabs--content {
        padding: 0px;
    }
}
.hidden-content {
    width: fit-content;
    overflow: visible;
}
.disabled {
    button {
        transform: none !important;
    }
}

::v-deep .vs-tabs--li button {
    font-variant: none;
}
</style>
